module.exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};


//# sourceMappingURL=lv-LV.main.js.map
